module.exports = __webpack_public_path__ + "img/charity.64433400.png";